import client from './client'

export default {
  create({ email }) {
    return client
      .post('/api/password-requests.json', { json: { email } })
      .json()
  }
}
